import PropTypes from 'prop-types';

import { Tooltip, POSITIONS } from '@hivebrite/design-system/Tooltip';

const TooltipPanel = ({ children, withTooltip, text, position }) => {
  if (!withTooltip) {
    return children;
  }

  return (
    <Tooltip childrenElement={text} initialPosition={POSITIONS[position]}>
      {children}
    </Tooltip>
  );
};

TooltipPanel.propTypes = {
  children: PropTypes.node,
  withTooltip: PropTypes.bool,
  text: PropTypes.string,
  position: PropTypes.string,
};

TooltipPanel.defaultProps = {
  position: 'TOP-RIGHT',
};

export default TooltipPanel;
